export default __webpack_public_path__ + "static/media/Whistleblowing_1_(SE).8db54554.mp4";